import { ENTITIES_PERMISIONS } from 'components/common/PermissionsGate/constants';
import {
  HomeIcon,
  SalesIcon,
  FleetIcon,
  SellVehiclesIcon,
  LeasingIcon,
  ArmIcon,
  LogisticsIcon,
  BillingIcon,
  ServicesIcon,
  ProductsIcon,
  CatalogIcon,
  MarketplaceIcon,
  CRMIcon,
  DriversIcon,
  UnifiedViewIcon,
  ReportsIcon,
  UtilitiesIcon,
  AdminIcon,
  VisualsIcon,
  CreditCheckIcon,
} from '@components';
import { URLS } from './constants';
import { NAVIGATION_SECTION } from './Menu/constants';

export default (findEntity /* , isReturnInboxEnabled */) => [
  {
    title: NAVIGATION_SECTION.myHub.label,
    icon: HomeIcon,
    key: NAVIGATION_SECTION.myHub.value,
    options: [
      {
        title: 'My Tasks',
        key: 'my-tasks',
        url: URLS.myIssues,
      },
    ],
    section: NAVIGATION_SECTION.myHub.value,
  },
  {
    title: 'Overview',
    icon: HomeIcon,
    key: 'home',
    options: [
      {
        title: 'Power Bi',
        key: 'power-bi',
        url: URLS.home,
      },
      {
        title: 'Daily Bookings',
        key: 'daily-bookings',
        url: URLS.dailyBookings,
        entity: ENTITIES_PERMISIONS.ReadBookingsGraph,
      },
      {
        title: 'Generic Tickets',
        key: 'generic-tickets',
        url: URLS.genericTickets,
      },
    ],
    hide: !(findEntity([ENTITIES_PERMISIONS.ReadBookingsGraph]) === 0),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Sales',
    icon: SalesIcon,
    key: 'sales',
    options: [
      {
        title: 'Bookings',
        key: 'bookings',
        url: URLS.bookings,
        entity: ENTITIES_PERMISIONS.ReadBookings,
      },
      {
        title: 'Availability Table',
        key: 'availability',
        url: URLS.availability,
      },
      {
        title: 'Reservations',
        key: 'reservations',
        url: URLS.reservations,
      },
      {
        title: 'Campaigns',
        key: 'campaigns',
        url: URLS.campaigns,
      },
      {
        title: 'B2B',
        url: URLS.b2b,
        key: 'b2b',
        entity: ENTITIES_PERMISIONS.ReadB2B,
      },
      {
        title: 'Instatrade',
        key: 'instatrade',
        url: URLS.tradeTickets,
        entity: ENTITIES_PERMISIONS.ReadInstaTrade,
      },
    ],
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Fleet',
    key: 'fleet',
    icon: FleetIcon,
    options: [
      {
        title: 'Vehicles',
        key: 'fleetVehicles',
        url: URLS.fleetVehicles,
        entity: ENTITIES_PERMISIONS.ReadVehicles,
      },
      {
        title: 'Purchase Orders',
        key: 'procurementOrders',
        url: URLS.procurement,
        entity: ENTITIES_PERMISIONS.ReadProcurement,
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadVehicles,
      ENTITIES_PERMISIONS.ReadProcurement,
      ENTITIES_PERMISIONS.ReadBuyouts,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Sell Vehicles',
    icon: SellVehiclesIcon,
    key: 'sellVehicles',
    options: [
      {
        title: 'Availability',
        url: URLS.forSaleVehicles,
        key: 'availability-sale',
      },
      {
        title: 'Vehicles',
        url: URLS.sellVehicles,
        key: 'sell-vehicles',
        entity: ENTITIES_PERMISIONS.ReadVehicles,
      },
      {
        title: 'Leasing Buyouts',
        url: URLS.buyout,
        path: 'buyout',
        key: 'buyout',
        entity: ENTITIES_PERMISIONS.ReadBuyouts,
      },
      {
        title: 'Requests',
        url: URLS.sellRequests,
        path: 'sellRequests',
        key: 'sellRequests',
        entity: ENTITIES_PERMISIONS.ReadBuyouts, // Change to ReadSaleRequests
      },
      {
        title: 'Defleet',
        url: URLS.defleet,
        path: 'defleet',
        key: 'defleet',
        entity: ENTITIES_PERMISIONS.ReadDefleets,
      },
      {
        title: 'Sell Vehicles B2B',
        url: URLS.sellVehiclesB2B,
        key: 'sell-vehicles-b2b',
        entity: ENTITIES_PERMISIONS.ReadVehicleSalesB2B,
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadVehicles,
      ENTITIES_PERMISIONS.ReadBuyouts,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Customer Success',
    icon: LeasingIcon,
    key: 'leasing',
    options: [
      // {
      //   title: 'Inbox',
      //   url: URLS.returns,
      //   key: 'returns',
      //   hide: !isReturnInboxEnabled || isReturnInboxEnabled === 'false',
      // },
      {
        title: 'Dashboard',
        key: 'customerSuccessDashboard',
        url: URLS.customerSuccessDashboard,
      },
      {
        title: 'Subscriptions',
        url: URLS.subscriptions,
        key: 'subscriptions',
        entity: ENTITIES_PERMISIONS.ReadSubscriptions,
      },
      {
        title: 'Green Card',
        url: URLS.greenCard,
        key: 'greenCard',
        entity: ENTITIES_PERMISIONS.ReadGreenCards,
      },
      {
        title: 'Traffic offenses',
        url: URLS.trafficOffenses,
        key: 'trafficOffenses',
        entity: ENTITIES_PERMISIONS.ReadTrafficOffenses, // Change to ReadSaleRequests
      },
      {
        title: 'Contracts',
        url: URLS.contracts,
        key: 'subscriptionContracts',
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadSubscriptions,
      ENTITIES_PERMISIONS.ReadTrafficOffenses,
      ENTITIES_PERMISIONS.ReadGreenCards,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'AR&M',
    icon: ArmIcon,
    key: 'arm',
    options: [
      {
        title: 'Dashboard',
        key: 'arnmDashboard',
        url: URLS.arnmDashboard,
      },
      {
        title: 'Repairs',
        key: 'arnmRepairs',
        url: URLS.arnmRepairs,
        entity: ENTITIES_PERMISIONS.ReadRepairs,
      },
      {
        title: 'Maintenance',
        key: 'arnmMaintenance',
        url: URLS.arnmMaintenance,
        entity: ENTITIES_PERMISIONS.ReadMaintenance,
      },
      {
        title: 'Accidents/Claims',
        key: 'arnmAccidents',
        url: URLS.arnmAccidents,
        entity: ENTITIES_PERMISIONS.ReadAccidentsClaims,
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadRepairs,
      ENTITIES_PERMISIONS.ReadMaintenance,
      ENTITIES_PERMISIONS.ReadAccidentsClaims,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Logistics',
    icon: LogisticsIcon,
    key: 'new-logistics',
    options: [
      {
        title: 'Table',
        key: 'logistics-table',
        url: URLS.logistics,
      },
      {
        title: 'Drivers',
        key: 'logistics-drivers',
        url: URLS.drivers,
      },
    ],
    hide: !findEntity([ENTITIES_PERMISIONS.ReadLogistics]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Billing',
    icon: BillingIcon,
    key: 'billing',
    options: [
      {
        title: 'Billing Table',
        key: 'billing-table',
        url: URLS.billing,
        entity: ENTITIES_PERMISIONS.ReadBillingTickets,
      },
      // TODO: Uncomment when the feature is ready and add the correct permission
      // {
      //   title: 'Guarantee Returns',
      //   key: 'guarantee-returns',
      //   url: URLS.guaranteeReturns,
      //   entity: ENTITIES_PERMISIONS.ReadGuaranteeReturns,
      // },
    ],
    hide: !findEntity([ENTITIES_PERMISIONS.ReadBillingTickets]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Services',
    icon: ServicesIcon,
    key: 'services',
    options: [
      {
        title: 'Inbox',
        key: 'serviceVehicles',
        url: URLS.serviceVehicles,
        entity: ENTITIES_PERMISIONS.ReadServiceVehicles,
      },
      {
        title: 'Insurances',
        key: 'insurances',
        url: URLS.insurances,
        entity: ENTITIES_PERMISIONS.ReadInsurances,
      },
      {
        title: 'Roadside Assistance',
        key: 'roadsideAssistance',
        url: URLS.roadsideAssistance,
        entity: ENTITIES_PERMISIONS.ReadRoadsideAssistance,
      },
      {
        title: 'Service Points',
        key: 'servicePoints',
        url: URLS.servicePoints,
        entity: ENTITIES_PERMISIONS.ReadServicePoints,
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadServiceVehicles,
      ENTITIES_PERMISIONS.ReadInsurances,
      ENTITIES_PERMISIONS.ReadRoadsideAssistance,
      ENTITIES_PERMISIONS.ReadServicePoints,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Products',
    icon: ProductsIcon,
    key: 'products',
    options: [
      {
        title: 'Products Table',
        key: 'products-table',
        url: '/products',
      },
    ],
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Catalog',
    icon: CatalogIcon,
    key: 'catalog',
    options: [
      {
        title: 'Cars',
        key: 'catalogCars',
        url: URLS.catalogCars,
        entity: ENTITIES_PERMISIONS.ReadVehicleCatalog,
      },
      {
        title: 'Ebikes',
        key: 'catalogEbikes',
        url: URLS.catalogEbikes,
        entity: ENTITIES_PERMISIONS.ReadVehicleCatalog,
      },
      {
        title: 'Competition',
        key: 'competition',
        url: URLS.competition,
        entity: ENTITIES_PERMISIONS.ReadCompetitionVehicles,
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadVehicleCatalog,
      ENTITIES_PERMISIONS.ReadVehicleCatalog,
      ENTITIES_PERMISIONS.ReadVehicleCatalog,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Marketplace',
    icon: MarketplaceIcon,
    key: 'marketplace',

    options: [
      {
        title: 'Tires',
        key: 'marketplaceTires',
        url: URLS.marketplaceTires,
        entity: ENTITIES_PERMISIONS.ReadTires,
      },
      {
        title: 'Car Wash',
        key: 'car-wash',
      },
      {
        title: 'Vendors',
        key: 'vendors',
        url: URLS.vendors,
        hide: true,
      },
      {
        title: 'Orders',
        key: 'orders',
        url: URLS.orders,
        entity: ENTITIES_PERMISIONS.ReadOrders,
      },
    ],
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'CRM',
    icon: CRMIcon,
    key: 'crm',
    options: [
      {
        title: 'Users',
        key: 'users',
        url: URLS.users,
        entity: ENTITIES_PERMISIONS.ReadUsers,
      },
      {
        title: 'Payments',
        key: 'payments',
      },
      {
        title: 'Private Vehicles',
        key: 'privateVehicles',
        url: URLS.privateVehicles,
        entity: ENTITIES_PERMISIONS.ReadCustomerVehicles,
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadUsers,
      ENTITIES_PERMISIONS.ReadCustomerVehicles,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Drivers',
    icon: DriversIcon,
    key: 'drivers',
    options: [
      {
        title: 'Delivery',
        key: 'handoverCarsDelivery',
        url: URLS.handoverCarsDelivery,
        entity: ENTITIES_PERMISIONS.ReadDeliveryReturn,
      },
      {
        title: 'Returns',
        key: 'handoverCarsReturns',
        url: URLS.handoverCarsReturns,
        entity: ENTITIES_PERMISIONS.ReadDeliveryReturn,
      },
      {
        title: 'Inspections',
        key: 'inspections',
        url: URLS.inspections,
        entity: ENTITIES_PERMISIONS.ReadDeliveryReturn,
      },
    ],
    hide: !findEntity([ENTITIES_PERMISIONS.ReadDeliveryReturn]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Unified View',
    icon: UnifiedViewIcon,
    key: 'unified-view',
    options: [
      {
        title: 'Mailboxes',
        key: 'communication',
        url: URLS.communication,
        entity: ENTITIES_PERMISIONS.ReadEmails,
      },
      {
        title: 'Templates',
        key: 'emailTemplates',
        url: URLS.emailTemplates,
        entity: ENTITIES_PERMISIONS.ReadEmailTemplates,
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadEmails,
      ENTITIES_PERMISIONS.ReadEmailTemplates,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Credit Check',
    icon: CreditCheckIcon,
    key: 'credit-check',
    options: [
      {
        title: 'Reports',
        key: 'creditCheckReport',
        url: URLS.creditCheckReport,
        entity: ENTITIES_PERMISIONS.ReadCreditCheck,
      },
      {
        title: 'Credit Check Table',
        key: 'creditCheckTable',
        url: URLS.creditCheckTable,
        entity: ENTITIES_PERMISIONS.ReadCreditCheck,
      },
    ],
    hide: !findEntity([ENTITIES_PERMISIONS.ReadCreditCheck]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Reports',
    icon: ReportsIcon,
    key: 'reports',
    options: [
      {
        title: 'Instapayment Reports',
        key: 'instapaymentReports',
        url: URLS.instapaymentReports,
        entity: ENTITIES_PERMISIONS.ReadInstapaymentReport,
      },
      {
        title: 'AVIS Report',
        key: 'avisReport',
        url: URLS.avisReport,
        entity: ENTITIES_PERMISIONS.ReadAvisReport,
      },
      {
        title: 'ARNM Reports',
        key: 'arnm_sla_reports',
        url: '/arnm_sla_reports',
        entity: ENTITIES_PERMISIONS.ReadARNMReport,
      },
      {
        title: 'Export Data',
        key: 'exportData',
        url: URLS.exportData,
        entity: ENTITIES_PERMISIONS.ReadExportData,
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadInstapaymentReport,
      ENTITIES_PERMISIONS.ReadAvisReport,
      ENTITIES_PERMISIONS.ReadARNMReport,
      ENTITIES_PERMISIONS.ReadExportData,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Utilities',
    icon: UtilitiesIcon,
    key: 'utilities',
    options: [
      {
        title: 'Tools',
        url: URLS.utilities,
        key: 'tools',
        entity: !findEntity([
          ENTITIES_PERMISIONS.UseVatFinder,
          ENTITIES_PERMISIONS.UseOCR,
        ]),
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.UseVatFinder,
      ENTITIES_PERMISIONS.UseOCR,
    ]),
    section: NAVIGATION_SECTION.workspace.value,
  },
  {
    title: 'Admin Area',
    icon: AdminIcon,
    key: 'admin',
    options: [
      {
        title: 'Agents',
        key: 'agents',
        url: URLS.agents,
        entity: ENTITIES_PERMISIONS.ReadAgents,
      },
      {
        title: 'Teams',
        key: 'teams',
        url: URLS.teams,
        entity: ENTITIES_PERMISIONS.ReadTeams,
      },
      {
        title: 'Configuration',
        key: 'configurations',
        url: URLS.configurations,
        entity: ENTITIES_PERMISIONS.ReadConfigurations,
      },
      {
        title: 'Permissions',
        key: 'permissions',
        url: URLS.permissions,
        entity: ENTITIES_PERMISIONS.ReadPermissions,
      },
      {
        title: 'Partners',
        key: 'partners',
        url: URLS.partners,
        entity: ENTITIES_PERMISIONS.ReadPartners,
      },
      {
        title: 'Email Boxes',
        key: 'mailBoxes',
        url: URLS.mailBoxes,
        entity: ENTITIES_PERMISIONS.ReadMailboxes,
      },
    ],
    hide: !findEntity([
      ENTITIES_PERMISIONS.ReadAgents,
      ENTITIES_PERMISIONS.ReadConfigurations,
      ENTITIES_PERMISIONS.ReadPermissions,
      ENTITIES_PERMISIONS.ReadPartners,
      ENTITIES_PERMISIONS.ReadMailboxes,
    ]),
    section: NAVIGATION_SECTION.admin.value,
  },
  {
    title: 'Visuals',
    icon: VisualsIcon,
    key: 'visuals',
    options: [
      {
        title: 'Videos',
        url: URLS.videos,
        key: 'videos',
        entity: ENTITIES_PERMISIONS.ReadVideos,
      },
    ],
    hide: !findEntity([ENTITIES_PERMISIONS.ReadVideos]),
    section: NAVIGATION_SECTION.workspace.value,
  },
];
